<template>
  <div class="main-wrapper coming-soon-page">
    <!-- Page Content -->
    <div class="content ellipses maintenance">
      <div class="container">
        <div class="row vph-100 d-flex align-items-center">
          <div class="col-sm-10 col-md-10 col-lg-10 mx-auto text-center">
            <!-- Header -->
            <header class="text-center">
              <router-link to="/index">
                <img src="@/assets/img/logo-black.svg" class="img-fluid" alt="Logo" />
              </router-link>
            </header>
            <!-- /Header -->
            <div class="text-img">
              <img
                src="@/assets/img/maintenance.jpg"
                class="img-fluid"
                alt="Coming-Soon"
              />
            </div>
            <div class="col-sm-10 col-md-10 col-lg-10 mx-auto text-center">
              <h2>
                This site is currently <br />
                under maintenance
              </h2>
              <p>We apologize for the inconvenience caused We’ve almost done.</p>
              <router-link to="/index" class="btn btn-primary btn-icon"
                >Go to Home<i class="feather-arrow-right-circle ms-2"></i
              ></router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Content -->
  </div>
</template>
